export const TableRowWidgetId = 'TableRowWidget';

export enum TableRowWidgetAttributes {
  CELLS = 'cells',
}
